import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const FeaturedCategories = () => {
  const featuredCategories = [
    {
      name: 'Dressers',
      image: 'https://images.unsplash.com/photo-1595428774223-ef52624120d2?w=800&h=600&fit=crop&auto=format',
      description: 'Elegant storage solutions',
      link: '/products?category=dressers',
      featured: true, // Main featured category
      bgColor: 'bg-amber-50'
    },
     {
      name: 'Wardrobes',
      image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop&auto=format',
      description: 'Spacious clothing storage',
      link: '/products?category=wardrobes',
      bgColor: 'bg-blue-50'
    },
    {
      name: 'Chest Drawer',
      image: 'https://images.unsplash.com/photo-1594620302200-9a762244a156?w=800&h=600&fit=crop&auto=format',
      description: 'Stylish display units',
      link: '/products?category=chest-drawers',
      bgColor: 'bg-rose-50'
    },
    {
      name: 'Wooden Beds',
      image: 'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=1200&h=800&fit=crop&auto=format',
      description: 'Premium quality bed frames crafted from solid wood',
      link: '/products?category=wooden-beds',
      bgColor: 'bg-sage-100',
      badge: 'BEST SELLERS'
    },
    
  ];

  const mainCategory = featuredCategories[0];
  const otherCategories = featuredCategories.slice(1);

  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="container mx-auto px-4">
        
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <p className="text-sm font-semibold text-primary-600 tracking-wider uppercase mb-2">
            EXPLORE OUR COLLECTIONS
          </p>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-dark-900 mb-4">
            Shop by Category
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Premium furniture for every room in your home
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6">
          
          {/* MAIN FEATURED CATEGORY - Takes 2 columns on desktop */}
          <Link
            to={mainCategory.link}
            className="lg:col-span-2 group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500"
          >
            <div className={`${mainCategory.bgColor} relative h-[500px] lg:h-[605px]`}>
              
              {/* Background Image */}
              <img
                src={mainCategory.image}
                alt={mainCategory.name}
                className="absolute inset-0 w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
              />
              
              {/* Gradient Overlay - Subtle */}
              <div className="absolute inset-0 bg-gradient-to-t from-dark-900/80 via-dark-900/20 to-transparent" />
              
              {/* Content */}
              <div className="absolute inset-0 flex flex-col justify-end p-8 md:p-12 text-white">
                {mainCategory.badge && (
                  <span className="inline-block w-fit px-4 py-2 bg-primary-600 text-white text-xs font-bold rounded-full mb-4">
                    {mainCategory.badge}
                  </span>
                )}
                
                <h3 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold mb-4">
                  {mainCategory.name}
                </h3>
                
                <p className="text-lg md:text-xl text-white/90 mb-6 max-w-lg">
                  {mainCategory.description}
                </p>
                
                <button className="inline-flex items-center gap-2 px-8 py-4 bg-white text-dark-900 rounded-xl font-semibold hover:bg-gray-100 transition-all duration-300 transform group-hover:scale-105 w-fit shadow-lg">
                  SHOP NOW
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </button>
              </div>
            </div>
          </Link>

          {/* OTHER CATEGORIES - Grid on the right */}
          <div className="flex flex-col gap-6 lg:gap-8">
            {otherCategories.map((category, index) => (
              <Link
                key={category.name}
                to={category.link}
                className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-all duration-500"
              >
                <div className={`${category.bgColor} relative h-[180px]`}>
                  
                  {/* Background Image */}
                  <img
                    src={category.image}
                    alt={category.name}
                    className="absolute inset-0 w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                  />
                  
                  {/* Light overlay */}
                  <div className="absolute inset-0 bg-gradient-to-r from-dark-900/70 to-dark-900/30" />
                  
                  {/* Content */}
                  <div className="absolute inset-0 flex flex-col justify-center p-6 text-white">
                    <h4 className="text-2xl md:text-3xl font-display font-bold mb-2">
                      {category.name}
                    </h4>
                    <p className="text-sm text-white/90 mb-3">
                      {category.description}
                    </p>
                    <span className="inline-flex items-center gap-1 text-sm font-semibold group-hover:gap-2 transition-all">
                      SHOP NOW
                      <ArrowRight className="w-4 h-4" />
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* View All Button */}
        <div className="text-center mt-12">
          <Link
            to="/shop"
            className="inline-flex items-center gap-2 px-8 py-4 bg-primary-600 text-white rounded-xl font-semibold hover:bg-primary-700 transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            View All Categories
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedCategories;